import { PercentageString } from "@shared/types";
import { css, htmlArray } from "../helpers/webComponents";

type ScreenActionAttributes = {
    alias: string | null;
    name: string | null;
    coordinateX: PercentageString | null;
    coordinateY: PercentageString | null;
    sizeX: PercentageString | null;
    sizeY: PercentageString | null;
    media: string | null;
};

/** CSS affecting the {@link ScreenActionComponent} */
const styles: string = css`
    .screen-button {
        cursor: pointer;
        position: absolute;

        aspect-ratio: 1 / 1;
        width: 10%;

        transform: translate(-50%, -50%);

        /* background-color: rgba(255, 0, 0, 0.5) */
    }

    .screen-button-name {
        cursor: pointer;
        position: absolute;

        background-color: rgba(0, 0, 0, 0.5);
    }

    .screen-button img,
    .screen-button-name img {
        width: 100%;
        height: 100%;
    }
`;

/**
 * The component that visualizes the ScreenActions on the game
 */
export class ScreenActionComponent extends HTMLElement {
    /** Attributes to observe */
    public static observedAttributes = ["alias", "name", "coordinateX", "coordinateY", "sizeX", "sizeY", "media"];

    /**
     * The "constructor" of a Web Component
     */
    public connectedCallback(): void {
        this.attachShadow({ mode: "open" });

        this.updateActionState();
    }

    /**
     * Runs when one of the attributes has changed
     */
    public attributeChangedCallback(): void {
        this.updateActionState();
    }

    /**
     * Get all the values of the attributes
     * @returns The attributes
     */
    private getAttributeValues(): ScreenActionAttributes {
        return {
            alias: this.getAttribute("alias"),
            name: this.getAttribute("name"),
            coordinateX: this.getAttribute("coordinateX"),
            coordinateY: this.getAttribute("coordinateY"),
            sizeX: this.getAttribute("sizeX"),
            sizeY: this.getAttribute("sizeY"),
            media: this.getAttribute("media"),
        } as ScreenActionAttributes;
    }

    /**
     * Render the contents of this action
     */
    private updateActionState(): void {
        if (!this.shadowRoot) {
            return;
        }

        const attributes: ScreenActionAttributes = this.getAttributeValues();
        const hasName: boolean = attributes.alias !== attributes.name ? true : false;

        const actionElement: HTMLElement[] = htmlArray`
            <style>
                ${styles}
            </style>
            <a
                class="${hasName ? "screen-button-name" : "screen-button"}"
                style="left: ${attributes.coordinateX}; top: ${attributes.coordinateY}; 
                        ${attributes.sizeX ? `width: ${attributes.sizeX};` : ""}
                        ${attributes.sizeY ? `height: ${attributes.sizeY};` : ""}"
            >
                ${hasName ? attributes.name : ""}${attributes.media ? `<img src="/assets/img/actions/${attributes.media}.png" />` : ""}
            </a>
        `;

        this.shadowRoot.replaceChildren(...actionElement);
    }
}
